import axios from "axios";




// old working Code

// const server = "https://api.tripplanner.ae";

// export const makePostRequest = async (endPoint, params = {}) => {
//   let token = localStorage.getItem("token");
//   if (!token) {
//     // navigate("/login");
//     // window.location.href = "/login";
//     return;
//   }

//   try {
//     // const response = await axios.post(`${server}/${endpoint}`, params, {
//     //   headers: {
//     //     Accept: "application/json",
//     //     Authorization: `Bearer ${token}`,
//     //   },
//     // });
//     return await axios
//       .post(`${server}/${endPoint}`, params, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//       })
//       .then((response) => response.data)
//       .catch((err) => {
//         throw err;
//       });
//   } catch (error) {
//     console.error(error);
//     return;
//   }
// };



//------------------------------------------------------------------


// const apiHost1 = localStorage.getItem("MobileApiHost");
// const server = `https://api.${apiHost1}`

// // old before local data base is added
// export const makePostRequest = async (endPoint, params = {}) => {
//   let token = localStorage.getItem("token");
//   if (!token) {
//     // navigate("/login");
//     // window.location.href = "/login";
//     return;
//   }

//   try {
  
//     return await axios
//       .post(`${server}/${endPoint}?local=api`, params, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//       })
//       .then((response) => response.data)
//       .catch((err) => {
//         throw err;
//       });
//   } catch (error) {
//     console.error(error);
//     return;
//   }
// };


const apiHost1 = localStorage.getItem("MobileApiHost");
const server = `https://api.${apiHost1}`;

export const makePostRequest = async (endPoint, params = {}) => {
  let token = localStorage.getItem("token");
  if (!token) {
    // navigate("/login");
    // window.location.href = "/login";
    return;
  }

  try {
    // ✅ build base URL
    let baseUrl = `${server}/${endPoint}`;

    // ✅ append local param only if needed
    let finalUrl = baseUrl + window.getLocalApiQuery(baseUrl);

    return await axios
      .post(finalUrl, params, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((response) => response.data)
      .catch((err) => {
        throw err;
      });
  } catch (error) {
    console.error(error);
    return;
  }
};
